import { AvatarLinksFF } from '../../../../../customized/fours-fringand-fr/components/App/header/AvatarLinks/AvatarLinksFF';
import { FWAvatarLinks } from '../../../../../customized/fresh-watch/components/auth/AuthLayout/AvatarMenuLinks';
import { ToggleComponent } from '../../../../../featureToggle';
import { AvatarLinks } from './AvatarLinks';

export default ToggleComponent(AvatarLinks, {
  styledComponentsVariants: {
    'fresh-watch': FWAvatarLinks,
    'fours-fringand-fr': AvatarLinksFF,
  },
});
